var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogContainer",
    {
      attrs: {
        showDialog: _vm.showDialog,
        title: "Add Activity Type",
        icon: "add",
        toolbarActions: [
          {
            text: "Save",
            icon: "save",
            buttonColor: "success",
            emitEvent: "onSubmitClicked",
            showIsLoading: true,
            isDisabledFunc: () => !_vm.isFormValid,
          },
          {
            text: "Cancel",
            depressed: true,
            emitEvent: "onCancelClicked",
          },
        ],
        isLoading: _vm.isLoading,
      },
      on: {
        onCancelClicked: _vm.onCancelClicked,
        onSubmitClicked: _vm.onSubmitClicked,
      },
    },
    [
      _c(
        "v-container",
        { attrs: { "pa-0": "", "grid-list-lg": "" } },
        [
          _c(
            "v-form",
            {
              ref: "form",
              model: {
                value: _vm.isFormValid,
                callback: function ($$v) {
                  _vm.isFormValid = $$v
                },
                expression: "isFormValid",
              },
            },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("ControlTextField", {
                        attrs: {
                          label: "Activity Type Name*",
                          autofocus: "",
                          disabled: _vm.isLoading,
                          rules: [(v) => !!v || "Required"],
                        },
                        model: {
                          value: _vm.name,
                          callback: function ($$v) {
                            _vm.name = $$v
                          },
                          expression: "name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("ControlCheckbox", {
                        attrs: {
                          label:
                            "Can the equipment location change after this activity?",
                          disabled: _vm.isLoading,
                        },
                        model: {
                          value: _vm.isLocationChange,
                          callback: function ($$v) {
                            _vm.isLocationChange = $$v
                          },
                          expression: "isLocationChange",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("ControlCheckbox", {
                        attrs: {
                          label:
                            "Can the equipment status change after this activity?",
                          disabled: _vm.isLoading,
                        },
                        model: {
                          value: _vm.isStatusChange,
                          callback: function ($$v) {
                            _vm.isStatusChange = $$v
                          },
                          expression: "isStatusChange",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isStatusChange
                    ? _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("ControlAutoComplete", {
                            attrs: {
                              items: _vm.enabledAssetStatuses,
                              autocomplete: "",
                              multiple: "",
                              "item-text": "name",
                              "item-value": "id",
                              clearable: "",
                              label:
                                "Equipment statuses that can be set during this activity*",
                              disabled: _vm.isLoading,
                              rules: [(v) => (v && v.length > 0) || "Required"],
                            },
                            model: {
                              value: _vm.assetStatusIds,
                              callback: function ($$v) {
                                _vm.assetStatusIds = $$v
                              },
                              expression: "assetStatusIds",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("small", [_vm._v("*indicates required field")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }